import { combineI18nMessages, defaultMessagesEN } from "@duosoftbg/nacid-components";

const messagesEn = combineI18nMessages(defaultMessagesEN, {
  translation: {
    "t.page.registers": "Registers and databases",
    "t.eRegisters": "Registers and databases",
    "t.ePortal": "Electronic portal",
    "t.page.professionalQualifications": "Registers for professional qualifications",
    "t.page.academicRecognition": "Registers for academic recognitions",
    "t.academicRecognition.nacid": "Academic recognitions from NACID",
    "t.academicRecognition.universities": "Academic recognition with decisions of universities",
    "t.detail.academicRecognition": "View academic recognition",
    "t.detail.academicRecognition.nacid": "Academic recognition from NACID",
    "t.detail.academicRecognition.universities": "View academic recognition with decisions of universities",
    "t.detail.professional.qualification": "View professional qualification",
    "t.modal.searchFilters.instruction": "Please select relevant search criteria",
    "t.modal.searchFilters.searchCriteria": "Search criteria",
    "t.acArUniEntryRequest":
      "Administration of details entry in register Academic recognition with decisions of universities",
    "t.acArUniEntryRequest.view": "View",
    "t.arUniEntryRequest": "Request for details entry in register Academic recognition with decisions of universities",
    "t.arUniEntryRequest.new.short": "New",
    "t.arUniEntryRequest.edit.short": "Edit",
    "t.arUniEntryRequest.view.short": "View",
    "t.arUniEntryRequest.list.short": "List",
    "t.arUniEntryRequest.new":
      "New request for details entry in register Academic recognition with decisions of universities",
    "t.arUniEntryRequest.edit":
      "Edit request for details entry in register Academic recognition with decisions of universities",
    "t.arUniEntryRequest.view":
      "View request for details entry in register Academic recognition with decisions of universities",
    "t.arUniEntryRequest.list":
      "List of requests for details entry in register Academic recognition with decisions of universities",
    "t.arUniEntryRequest.applicant.details": "Diploma owner",
    "t.arUniEntryRequest.notes": "Notes",
    "t.arUniEntryRequest.recognized.details": "Recognized details",
    "t.arUniEntryRequest.diplomaUni.details": "Foreign university and diploma details",
    "t.arUniEntryRequest.common.details": "General information",
    "t.arUniEntryRequest.confirm.dialog": "Please confirm",
    "t.arUniEntryRequest.relatedRecognition.details": "Previous register entry",
    "t.seRecognition.checkup": "View by document code",
    "t.seRecognition.checkup.short": "View by document code",
    "t.seRecognition.qr.view": "View by QR code",
    "t.seRecognition.qr.view.short": "View by QR code",

    "l.searchFilter.nameExactMatch": "Name",
    "l.searchFilter.exactMatch": "Exact match",
    "l.searchFilter.applicationDate": "Application date",
    "l.searchFilter.applicant": "Applicant",
    "l.searchFilter.status": "Status",
    "l.searchFilter.country": "Country",
    "l.searchFilter.acquiredSpeciality": "Acquired speciality",
    "l.searchFilter.protocolNumber": "Academic Council decision",
    "l.searchFilter.eduLevel": "Education level",
    "l.searchFilter.university": "University",
    "l.searchFilter.foreignUniversity": "Foreign university",
    "l.searchFilter.recognizedSpeciality": "Recognized speciality",
    "l.searchFilter.recordNumber": "Appl. №",
    "l.searchFilter.decisionNumber": "Decision №",
    "l.searchFilter.recognizedProfessionName": "Recognized profession name",
    "l.searchFilter.applicationCountryName": "Application country name",
    "l.table.head.recognizedProfessionName": "Recognized profession name",
    "l.table.head.applicationCountryName": "Application country name",
    "l.table.head.recordNumber": "Appl. №",
    "l.table.head.date": "Date",
    "l.table.head.applicant": "Applicant",
    "l.table.head.university": "University",
    "l.table.head.foreignUniversity": "Foreign University",
    "l.table.head.country": "Country",
    "l.table.head.recognizedSpeciality": "Recognized speciality",
    "l.table.head.acquiredSpeciality": "Acquired speciality",
    "l.table.head.recognizedEduLevel": "Recognized EDU level",
    "l.table.head.acquiredEduLevel": "Acquired EDU level",
    "l.table.head.certificateNumber": "Certificate №",
    "l.table.head.decisionNumber": "Decision №",
    "l.table.head.academicCouncilDecision": "Academic Council decision",
    "l.table.head.academicCouncilProtocol": "Academic Council protocol",
    "l.detail.applicationNumber": "Application №",
    "l.detail.applicationDate": "Application date",
    "l.detail.applicantName": "Applicant",
    "l.detail.university": "University",
    "l.detail.foreignUniversity": "Foreign university",
    "l.detail.universityCountry": "Country",
    "l.detail.originalSpeciality": "Speciality",
    "l.detail.originalEduLevel": "Education level",
    "l.recognizedSpeciality": "Recognized speciality",
    "l.detail.recognizedEduLevel": "Recognized education level",
    "l.detail.applicationStatus": "Status",
    "l.detail.certificateNumber": "Certificate №",
    "l.detail.refusalLegalReason": "Refusal legal reason",
    "l.detail.invalidatedCertificateNumbers": "Invalidated certificates",
    "l.detail.citizenship": "Citizenship",
    "l.detail.educationLevel": "Acquired EDU level",
    "l.acquiredSpeciality": "Acquired speciality",
    "l.detail.diplomaNumber": "Diploma number",
    "l.detail.diplomaDate": "Diploma date",
    "l.detail.protocolNumber": "Academic Council protocol",
    "l.recognizedUniversity": "Recognized University",
    "l.detail.inputNumber": "Input number",
    "l.detail.outputNumber": "Output number",
    "l.detail.createdDate": "Created date",
    "l.detail.decisionNumber": "Decision №",
    "l.detail.notes": "Notes",
    "l.detail.recognitionStatus": "Status",
    "l.detail.relatedRecognition": "Input number of related recognition",
    "l.detail.applicationCountryName": "Application Country",
    "l.detail.recognizedProfessionName": "Recognized Profession Name",
    "l.btn.newEntryRequest": "New university entry request",
    "l.btn.myEntryRequests": "My university entry requests",
    "l.arUniEntryRequest.applicant": "Diploma owner names",
    "l.arUniEntryRequest.applicantEan": "EAN",
    "l.arUniEntryRequest.citizenship": "Diploma owner citizenship",
    "l.arUniEntryRequest.notes": "Notes and additional information",
    "l.arUniEntryRequest.recognizingUniversity": "Bulgarian university that recognized the diploma",
    "l.arUniEntryRequest.protocolNumber": "Recognition/rejection protocol number",
    "l.arUniEntryRequest.protocolDate": "Recognition/rejection protocol date",
    "l.arUniEntryRequest.recognitionStatus": "Decision kind",
    "l.arUniEntryRequest.recognizedSpeciality": "Recognized speciality",
    "l.arUniEntryRequest.recognizedEducationLevelId": "Recognized education/science degree",
    "l.arUniEntryRequest.university": "Name of the foreign university that issued the diploma",
    "l.arUniEntryRequest.universityCountry": "Country of foreign university that issued the diploma",
    "l.arUniEntryRequest.diplomaNumber": "Diploma number",
    "l.arUniEntryRequest.diplomaDate": "Diploma date",
    "l.arUniEntryRequest.diplomaSpeciality": "Diploma speciality",
    "l.arUniEntryRequest.educationLevel": "Gained education/science degree",
    "l.arUniEntryRequest.createdDate": "Creation date",
    "l.arUniEntryRequest.submittedDate": "Submission date",
    "l.arUniEntryRequest.createdUser": "Creator user",
    "l.arUniEntryRequest.requestStatus": "Record status",
    "l.btn.arUniEntryRequest.saveData": "Save entry request",
    "l.btn.arUniEntryRequest.saveAndPublishData": "Publish in register",
    "l.table.head.options": "Options",
    "l.button.accept.arUniEntryRequest":
      "Transfer data into register Academic recognition with decisions of universities",
    "l.arUniEntryRequest.filter.createdUser": "User who created the entry",
    "l.button.deny.arUniEntryRequest": "Deny transfer in register",
    "l.arUniEntryRequest.relatedRecognitionId": "Previous register entry",
    "l.arUniEntryRequest.acadrecUniId": "Corresponding register entry",
    "l.arUniEntryRequest.recognizedProfGroup": "Recognized professional referral",
    "l.click.here": "Click here to follow the link",

    "l.arUniEntryRequest.filter.applicant": "Diploma owner",
    "l.arUniEntryRequest.filter.university": "Foreign university",
    "l.arUniEntryRequest.filter.recognitionStatusId": "Decision kind",
    "l.arUniEntryRequest.filter.requestStatusId": "Status",
    "l.arUniEntryRequest.filter.recognizingUniversity": "Bulgarian university that recognized the diploma",

    "l.arUniEntryRequest.table.head.applicant": "Diploma owner",
    "l.arUniEntryRequest.table.head.recognizedEducationLevel": "Recognized education/science degree",
    "l.arUniEntryRequest.table.head.acquiredEduLevel": "Gained education/science degree",
    "l.arUniEntryRequest.table.head.protocolNumber": "Recognition/rejection order",

    "m.academicRecognition.desc":
      'The Unified Register for Academic Recognition provides information on all issued, denied, or annulled certificates for the recognition of higher education diplomas, the educational and scientific degree "Doctor," and the scientific degree "Doctor of Sciences." The register is organized into two subsections: one section for recognition by NACID aimed at facilitating access to the labor market, doctoral studies in a scientific organization, and other purposes where the applicant has a legal interest, and another section for recognition by higher education institutions for access to further education, qualification improvement training, and doctoral studies. The register allows unified searches across both subsections based on various criteria and a detailed view of the data for a single certificate in its entirety, in accordance with the legal framework.',
    "m.academicRecognition.desc.2": "The register contains data as follows:",
    "m.academicRecognition.desc.3": "- for bachelor and master - from April 2009.",
    "m.academicRecognition.desc.4": "- for doctor and doctor of sciences - from April 2019.",
    "m.professionalQualifications.desc":
      "The Unified Register of Professional Qualifications provides information on all issued, denied, or annulled certificates for acquired professional qualifications within the territory of the Republic of Bulgaria, required for access to or the practice of a regulated profession in another EU member state. The procedure for issuing qualification certificates for professions that are not regulated within the territory of the Republic of Bulgaria is organized by NACID. For professions regulated in Bulgaria, certificates are issued by the respective competent authorities. The register allows searches based on various criteria and provides a detailed view of the data for a single certificate in its entirety, in accordance with the legal framework.",
    "m.professionalQualifications.desc.2": "The register contains data from April 2011.",
    "m.hideSearchCriteria": "Hide search criteria",
    "m.showSearchCriteria": "Show search criteria",
    "m.resetFilters.success": "Reset operation has finished successfully!",
    "m.submitFilters.success": "Search operation has finished successfully!",
    "m.alert.pleaseEnterValidSearchCriteria": "Please review and fix validation errors related to search filters",
    "m.arUniEntryRequest.save.data.success": "You have saved the draft successfully",
    "m.arUniEntryRequest.saveAndPublish.data.success": "You have successfully published the data into the register",
    "m.arUniEntryRequest.reject.request.warn": "Are you sure you wish to reject this entry?",
    "m.arUniEntryRequest.accept.request.warn": "Are you sure you wish to transfer this entry to the register?",
    "m.arUniEntryRequest.saveAndPublish.request.warn":
      "With this action you will save your changes and then data will be published into the register. It is not advised to change the published details afterwards. Are you sure you wish to continue?",
    "m.arUniEntryRequest.reject.request.success": "Successfully rejected the entry",
    "m.arUniEntryRequest.accept.request.success": "Successfully transferred the entry into the register",
    "m.arUniEntryRequest.relatedRecognition.info":
      "When changing or reviewing a decision, please select here previous decision (order number and person name).",
    "m.warning.edit.accepted.register.record":
      "This record is already transfered into the register. Please, do not publish any changes unless absolutely necessary. NACID will get notified for the changes you publish. Do not abuse the provided options for edit.",
    "m.seRecognitionSearchTitle": "Secondary Education",
    "m.seRecognitionSearchDescription":
      "<strong>You have the ability to check issued:</strong><br><br><ul style='padding-left: 20px; margin: 0;'><li style='margin-bottom: 5px;'><strong>certificates</strong> for recognition of secondary education acquired in a school in a foreign country;</li><li style='margin-bottom: 5px;'><strong>affidavits</strong> for recognition of secondary education acquired in a school in a foreign country;</li><li style='margin-bottom: 5px;'><strong>official notes</strong> for equating grades in studied subjects that are not included in the document for completed secondary education;</li><li style='margin-bottom: 5px;'><strong>duplicates</strong> of the above-mentioned documents;</li><li style='margin-bottom: 5px;'><strong>refusal decisions</strong> for recognition of secondary education acquired in a school in a foreign country.</li></ul><br><div>For this purpose, enter the access code indicated in the document and press the <strong>\"Search\"</strong> button. The data from the document will be displayed, and to view its image, click on the provided link.</div><br><div>The database contains information about documents <strong>issued by NACID after 10.01.2025</strong>.</div>",
    "m.seRecognitionSearchInfoText": "Helpful information",
    "m.seRecognitionAccessCodeNotFound": "No results found for the specified criteria",
    "l.accessCode": "Document code",

    "l.diplomaOwner": "Diploma owner",
    "l.acquiredEduLevel": "Acquired educational level",
    "l.recognizedEduLevel": "Recognized educational level",
    "l.recognizeRejectOrder": "Recognize/Reject order",
    "l.decisionType": "Decision type",
    "l.application": "Application",
    "l.legalReason": "Legal reason",
    "l.denialDecision": "Denial decision",
    "l.certificate": "Certificate",
    "l.certificateAndWeakenedOrder": "Certificate/Weakened order",
    "l.qualificationFromDiploma": "Professional qualification from diploma",
    "l.recognizedQualification": "Recognized qualification",
    "l.trainingInstitution": "Training institution",
    "l.decisionProtocol": "Decision protocol",
    "l.recognized": "Recognized",
    "l.diplomaData": "Diploma",
    "l.applicationData": "Application data",
    "l.numberAndDate": "Number/date",
    "l.relatedEntries": "Related entries",
    "l.previousRecognition": "Previous recognitions",
    "l.nextRecognition": "Next recognitions",
    "l.detail.accessCode": "Document code",
    "l.detail.bgProfession": "Profession",
    "l.detail.schoolName": "School name",
    "l.detail.schoolSettlement": "School settlement",
    "l.detail.schoolCountry": "Country",
    "l.download.decision": "Download decision",
    "l.decisions": "Decisions",
    "m.document.notFound": "Document not found!",

    "m.info.ar.nacid":
      "NACID performs recognition to <strong>facilitate access to the labor market, doctoral studies in a scientific organization, and for other purposes where the applicant has a legal interest</strong>. The issued certificate is <strong>valid within the territory of the Republic of Bulgaria</strong>.",
    "m.info.ar.uni":
      "Higher education institutions perform recognition to enable <strong>access to further education, qualification improvement training</strong>, and <strong>doctoral studies</strong>. The decision taken is <strong>valid only within the respective institution for the purposes of admission there</strong>.",
  },
});

export default messagesEn;
